import React from "react";
//#region types
import { SelectionItem, SelectionKeyType } from "models/utilTypes/selectionTypes";
import { TabDialogContentType } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import AsyncResultListContainer from "./asyncResultListContainer";
//#endregion
import LocalizationHelperInstance from "utils/helpers/localizationHelper";

const AsyncResultListTabContent = (
  parentId: number,
  onListItemSelect: (item: SelectionItem) => void,
  getSuggestions: () => Promise<SelectionItem[] | undefined>,
  search: (str: string) => Promise<SelectionItem[]>,
  selectedIds?: SelectionItem[],
  onListItemRemove?: (id: SelectionKeyType) => void
): TabDialogContentType => [
  {
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
    content: (
      <AsyncResultListContainer
        parentId={parentId}
        onResultItemSelect={onListItemSelect}
        getResultList={getSuggestions}
        selectedIds={selectedIds}
        onResultItemRemove={onListItemRemove}
      />
    ),
  },
  {
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.All),
    content: (
      <AsyncResultListContainer
        parentId={parentId}
        onResultItemSelect={onListItemSelect}
        hasSearch={true}
        getResultList={search}
        selectedIds={selectedIds}
        onResultItemRemove={onListItemRemove}
      />
    ),
  },
];

export default AsyncResultListTabContent;
